import { Dropdown, RadioOption } from '@/components/Dropdown';
import { SortKey, getSortSlugBySortKey } from '@/resource/ad';

export function SortDropdown({
  id,
  sort,
  categoryIds,
  distance,
  postalCode,
  filterBy,
  keyword,
  hasLocation,
}: {
  id?: string;
  sort: SortKey;
  categoryIds: number[];
  distance: number;
  postalCode: string;
  keyword: string;
  hasLocation: boolean;
  filterBy: (value: {
    sort: SortKey;
    categoryIds: number[];
    distance: number;
    postalCode: string;
    keyword: string;
  }) => void;
}) {
  return (
    <Dropdown label={`Meest ${getSortSlugBySortKey(sort)}`} id={id}>
      <RadioOption
        name="sort"
        type="radio"
        value="recent"
        onChange={() =>
          filterBy({
            sort: 'recent',
            categoryIds,
            distance,
            postalCode,
            keyword,
          })
        }
        checked={'recent' === sort || !sort} // Recent is the default.
      >
        Meest recent
      </RadioOption>

      <RadioOption
        name="sort"
        type="radio"
        value="urgent"
        onChange={() =>
          filterBy({
            sort: 'urgent',
            categoryIds,
            distance,
            postalCode,
            keyword,
          })
        }
        checked={'urgent' === sort}
      >
        Meest urgent
      </RadioOption>

      <RadioOption
        name="sort"
        type="radio"
        value="relevant"
        onChange={() =>
          filterBy({
            sort: 'relevant',
            categoryIds,
            distance,
            postalCode,
            keyword,
          })
        }
        checked={'relevant' === sort}
        disabled={keyword.trim().length > 1 === false}
      >
        Meest relevant
      </RadioOption>

      <RadioOption
        name="sort"
        type="radio"
        value="adjacent"
        onChange={() =>
          filterBy({
            sort: 'adjacent',
            categoryIds,
            distance,
            postalCode,
            keyword,
          })
        }
        checked={'adjacent' === sort}
        disabled={!hasLocation}
      >
        Meest dichtbij
      </RadioOption>
    </Dropdown>
  );
}
